/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { ShipmentVoModel } from './shipment-vo.model';

export class RouteLoadVoModel extends JSONable {

  shipments: ShipmentVoModel[] | undefined = undefined;

  confirmedSumVolume: number | undefined = undefined;

  confirmedPcsNr: number | undefined = undefined;

  confirmedSumWeight: number | undefined = undefined;
}
